import {fsa, fsaError, fsaPayload, fsaPayloadByKeys} from './helpers'

export const START_CHECKOUT = 'checkout/start'
export const startCheckout = fsa(START_CHECKOUT)

export const PROCEED_TO_CHECKOUT = 'proceed to checkout'
export const proceedToCheckout = fsa(PROCEED_TO_CHECKOUT)

export const RESET_CHECKOUT_STEP = 'reset checkout step'
export const resetCheckoutStep = fsa(RESET_CHECKOUT_STEP)

export const SET_CHECKOUT_STEPS = 'checkout/set steps'
export const setCheckoutSteps = fsaPayloadByKeys(SET_CHECKOUT_STEPS, ['steps'])

export const GET_FIT_GUARANTEE = 'get fit guarantee'
export const getFitGuarantee = fsa(GET_FIT_GUARANTEE)

export const GET_FIT_GUARANTEE_PENDING = 'get fit guarantee pending'
export const getFitGuaranteePending = fsa(GET_FIT_GUARANTEE_PENDING)

export const GET_FIT_GUARANTEE_SUCCESS = 'get fit guarantee success'
export const getFitGuaranteeSuccess = fsaPayload(GET_FIT_GUARANTEE_SUCCESS)

export const GET_FIT_GUARANTEE_FAILURE = 'get fit guarantee failure'
export const getFitGuaranteeFailure = fsaError(GET_FIT_GUARANTEE_FAILURE)

export const GET_ORDER_SUMMARY = 'get order summary details for order'
export const getOrderSummary = fsaPayload(GET_ORDER_SUMMARY)

export const GET_ORDER_SUMMARY_PENDING = 'get order summary details pending'
export const getOrderSummaryPending = fsa(GET_ORDER_SUMMARY_PENDING)

export const GET_ORDER_SUMMARY_SUCCESS = 'get order summary details successfully fetched'
export const getOrderSummarySuccess = fsaPayload(GET_ORDER_SUMMARY_SUCCESS)

export const GET_ORDER_SUMMARY_FAILURE = 'get order summary details fetch failed'
export const getOrderSummaryFailure = fsaError(GET_ORDER_SUMMARY_FAILURE)

export const GET_SHIPPING_ADDRESS_PENDING = 'get shipping address is pending'
export const getShippingAddressPending = fsa(GET_SHIPPING_ADDRESS_PENDING)

export const GET_SHIPPING_ADDRESS_SUCCESS = 'get shipping address successful'
export const getShippingAddressSuccess = fsaPayload(GET_SHIPPING_ADDRESS_SUCCESS)

export const GET_SHIPPING_ADDRESS_FAILURE = 'get shipping address failed'
export const getShippingAddressFailure = fsaError(GET_SHIPPING_ADDRESS_FAILURE)

export const VALIDATE_PRECHECKOUT = 'validate precheckout'
export const validatePrecheckout = fsa(VALIDATE_PRECHECKOUT)

export const VALIDATE_PRECHECKOUT_FAILURE = 'validate precheckout failed'
export const validatePrecheckoutFailure = fsaError(VALIDATE_PRECHECKOUT_FAILURE)

export const VALIDATE_PRECHECKOUT_PENDING = 'validate precheckout pending'
export const validatePrecheckoutPending = fsa(VALIDATE_PRECHECKOUT_PENDING)

export const VALIDATE_PRECHECKOUT_SUCCESS = 'validate precheckout success'
export const validatePrecheckoutSuccess = fsaPayload(VALIDATE_PRECHECKOUT_SUCCESS)

export const ORDER_IS_VALID_PRECHECKOUT = 'order passed precheckout validation'
export const orderIsValidPrecheckout = fsa(ORDER_IS_VALID_PRECHECKOUT)

export const SAVE_SHIPPING_ADDRESS = 'save shipping address'
export const saveShippingAddress = fsaPayload(SAVE_SHIPPING_ADDRESS)

export const SAVE_SHIPPING_ADDRESS_PENDING = 'save shipping address is pending'
export const saveShippingAddressPending = fsa(SAVE_SHIPPING_ADDRESS_PENDING)

export const SAVE_SHIPPING_ADDRESS_FAILURE = 'save shipping address failed'
export const saveShippingAddressFailure = fsaError(SAVE_SHIPPING_ADDRESS_FAILURE)

export const SAVE_SHIPPING_ADDRESS_SUCCESS = 'save shipping address is successful'
export const saveShippingAddressSuccess = fsaPayload(SAVE_SHIPPING_ADDRESS_SUCCESS)

export const SAVE_BILLING_ADDRESS = 'save billing address'
export const saveBillingAddress = fsaPayload(SAVE_BILLING_ADDRESS)

export const SAVE_PARTNER_INFO = 'checkout/save partner info'
export const savePartnerInfo = fsaPayload(SAVE_PARTNER_INFO)

export const SAVE_PARTNER_INFO_SUCCESS = 'checkout/save partner info successful'
export const savePartnerInfoSuccess = fsaPayload(SAVE_PARTNER_INFO_SUCCESS)

export const SAVE_PARTNER_INFO_FAILURE = 'checkout/save partner info failure'
export const savePartnerInfoFailure = fsaError(SAVE_PARTNER_INFO_FAILURE)

export const SAVE_BILLING_ADDRESS_PENDING = 'save billing address pending'
export const saveBillingAddressPending = fsa(SAVE_BILLING_ADDRESS_PENDING)

export const SAVE_BILLING_ADDRESS_SUCCESS = 'save billing address successful'
export const saveBillingAddressSuccess = fsaPayload(SAVE_BILLING_ADDRESS_SUCCESS)

export const SAVE_BILLING_ADDRESS_FAILURE = 'save billing address failed'
export const saveBillingAddressFailure = fsaError(SAVE_BILLING_ADDRESS_FAILURE)

export const COMPLETE_CHECKOUT = 'complete checkout'
export const completeCheckout = fsa(COMPLETE_CHECKOUT)

export const COMPLETE_CHECKOUT_PENDING = 'complete checkout pending'
export const completeCheckoutPending = fsa(COMPLETE_CHECKOUT_PENDING)

export const COMPLETE_CHECKOUT_SUCCESS = 'complete checkout successful'
export const completeCheckoutSuccess = fsa(COMPLETE_CHECKOUT_SUCCESS)

export const COMPLETE_CHECKOUT_FAILURE = 'complete checkout failed'
export const completeCheckoutFailure = fsaError(COMPLETE_CHECKOUT_FAILURE)

export const SHOW_SUMMARY_LOADER = 'show summary loader animation'
export const showSummaryLoader = fsa(SHOW_SUMMARY_LOADER)

export const HIDE_SUMMARY_LOADER = 'hide summary loader animation'
export const hideSummaryLoader = fsa(HIDE_SUMMARY_LOADER)

export const UPDATE_CHECKOUT_VERSIONS = 'update checkout versions'
export const updateCheckoutVersions = fsaPayload(UPDATE_CHECKOUT_VERSIONS)

export const NAVIGATE_TO_CHECKOUT_STEP = 'navigate to checkout step'
/**
 * @param {Object} payload
 * @param {String} payload.currentStep The slug of the current step you'd like to navigate to
 * @param {String} payload.direction One of 'forward' or 'backward'
 */
export const navigateToCheckoutStep = fsaPayload(NAVIGATE_TO_CHECKOUT_STEP)

export const ACCEPT_CHECKOUT_PROMPT = 'accept checkout prompt'
export const acceptCheckoutPrompt = fsaPayloadByKeys(ACCEPT_CHECKOUT_PROMPT, ['type'])

export const TOGGLE_ACCOUNT_BALANCE_USE = 'checkout/toggle account balance use'
export const toggleAccountBalanceUse = fsa(TOGGLE_ACCOUNT_BALANCE_USE)
